const UNSPLASH_API = 'https://api.unsplash.com';
const accessKey = process.env.UNSPLASH_ACCESS_KEY || '';

export interface UnsplashPhoto {
  id: string;
  urls: { regular: string; small: string; thumb: string };
  alt_description: string | null;
  user: { name: string; links: { html: string } };
  links: { download_location: string };
}

interface SearchResponse {
  total: number;
  total_pages: number;
  results: UnsplashPhoto[];
}

export function isConfigured(): boolean {
  return accessKey.length > 0;
}

export async function searchPhotos(
  query: string,
  page = 1,
  perPage = 12
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    query,
    page: String(page),
    per_page: String(perPage),
  });

  const res = await fetch(`${UNSPLASH_API}/search/photos?${params}`, {
    headers: { Authorization: `Client-ID ${accessKey}` },
  });

  if (!res.ok) {
    throw new Error(`Unsplash API error: ${res.status}`);
  }

  return res.json();
}

export async function trackDownload(downloadLocation: string): Promise<void> {
  await fetch(downloadLocation, {
    headers: { Authorization: `Client-ID ${accessKey}` },
  }).catch(() => {
    // Best-effort — don't block the user if tracking fails
  });
}
